<template>
  <Row>
    <i-col>
      <Input
        v-model="value"
        :placeholder="placeholder"
        :disabled="true"
        style="width: 200px; margin-right: 5px"
      >
        <div slot="append">
          <Button type="ghost" :disabled="disabled" @click="openModel"
            >选择</Button
          >
        </div>
      </Input>
    </i-col>
    <i-col>
      {{ name }}
    </i-col>
    <Modal
      class-name="vertical-center-modal"
      v-model="modal"
      width="680"
      @on-ok="ok"
      :scrollable="false"
      :draggable="false"
    >
      <pop-user
        @on-click="clickRow"
        @on-select="select"
        @on-clear="clear"
        @on-ok="ok"
        @on-selectcancel="selectcancel"
        v-if="type == 'content_ids'"
        :query="query"
        :value="value"
      ></pop-user>
      <pop-tag
        @on-click="clickRow"
        @on-select="select"
        @on-clear="clear"
        @on-ok="ok"
        @on-selectcancel="selectcancel"
        v-if="type == 'tag_ids'"
        :query="query"
        :value="value"
      ></pop-tag>
      <pop-cases
        @on-click="clickRow"
        @on-select="select"
        @on-clear="clear"
        @on-ok="ok"
        @on-selectcancel="selectcancel"
        v-if="type == 'casescategory_id'"
        :query="query"
        :value="value"
      ></pop-cases>
      <pop-show
        @on-click="clickRow"
        @on-select="select"
        @on-clear="clear"
        @on-ok="ok"
        @on-selectcancel="selectcancel"
        v-if="type == 'showcategory_id'"
        :query="query"
        :value="value"
      ></pop-show>
      <pop-skill
        @on-click="clickRow"
        @on-select="select"
        @on-clear="clear"
        @on-ok="ok"
        @on-selectcancel="selectcancel"
        v-if="type == 'skillcategory_id'"
        :query="query"
        :value="value"
      ></pop-skill>
    </Modal>
  </Row>
</template>

<script>
import popUser from "../../../usertag/pop";
import popTag from "../../../user/pop";
import popCases from "../../../cases/pop";
import popSkill from "../../../skill/pop";
import popShow from "../../../show/pop";

export default {
  name: "popBoxcontent",
  components: {
    popUser,
    popTag,
    popCases,
    popSkill,
    popShow
  },
  props: {
    name: {
      type: String,
      default: "",
    },
    value: String | Number,
    type: String,
    placeholder: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    query: {
      type: Object,
      default: () => {
        return {};
      },
    }, // box的查询query
  },
  data() {
    return {
      row: null,
      modal: false,
    };
  },
  watch: {
    row(v) {
      // this.ajaxData()
    },
  },
  created() {},
  mounted() {},
  methods: {
    openModel() {
      this.modal = true;
        //  this.$refs.popUsers.ondata(); 
    },
    // clickRow(row) {
    //   if (row) {
    //     this.row = row
    //     let id = null
    //     // let nn = ''
    //       id = row.id
    //       // nn = row.user_nick
    //     try {
    //       this.$emit('input', id)
    //       // this.$emit('update:name', nn)
    //       // this.$emit('on-click', row)
    //       this.modal = false
    //       console.log('clickRow ', row)
    //     } catch (error) {
    //       console.log(error)
    //     }
    //   }
    // },
    select(row) {
      this.$emit("input", row);
    },
    selectcancel(selection,row){
      console.log('selectcancel2222', selection, row)
    },
    ok(){
      this.modal = false;
    },
    clear() {
      let row = {};
      row.user = {};
      this.$emit("input", row.id);
      // this.$emit('on-click', row)
      // this.modal = false;
      // this.clickRow(row)
      console.log("clear");
    },
  },
  watch: {},
  init() {},
};
</script>
<style lang="less">
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}
</style>
